import { Type } from "class-transformer"

export default class NomineeDeclarationModel {
    name!: string
    @Type(() => NomineeModel)
    nominee?: NomineeModel
    @Type(() => GuardianModel)
    guardian?: GuardianModel
}

export class NomineeModel {
    name?: string
    relationship?: string
    relationshipCode?: string
    status: string = "PENDING"
}

export class GuardianModel {
    name?: string
    relationshipCode?: string
    status: string = "PENDING"
}

export class NomineeApiReq {
    nominee?: string
    nomineeRelation?: string
    nomineeRelationCode?: string
    guardian?: string
    guardianRelationCode?: string
}

export class NomineeDetailsModel {
    name!: string
    @Type(() => NomineeUCCModel)
    nominee?: NomineeUCCModel
}

export class NomineeUCCModel {
    panNumber?: string
    nominee?: string
    nomineeRelation?: string
    nominee2?: string
    nominee2Relation?: string
    nominee3?: string
    nominee3Relation?: string
    nomineeRelationCode?: string
    nomineeGuardian?: string
    nomineeGuardianPan?: string
    nomineeAddress1?: string
    nomineeAddress2?: string
    nomineeAddress3?: string
    nomineeCity?: string
    nomineeCountry?: string
    nomineeDOB?: string
    nomineeEmail?: string
    nomineeIdentificationType?: string
    nomineeIdentificationNumber?: string
    nomineePhoneNumber?: string
    nomineePincode?: string
    nomineeShare?: number
    showNomineeInSoa?: boolean
    nomineeErrorRemark?: string
    permanentAddress?: Address
}

class Address {
    line1: string = ""
    line2: string = ""
    line3: string = ""
    city: string = ""
    pin: string = ""
}

export class NomineeUpdateRequest {
    showInSoa: boolean = false
    name: string = ""
    relationCode: string = ""
    dob: string = "" /// DD/MM/YYYY
    guardianName?: string = ""
    guardianPan?: string = ""
    identificationType: string = ""
    identificationNumber: string = ""
    email: string = ""
    phoneNumber: string = ""
    address1: string = ""
    address2?: string
    address3?: string
    city: string = ""
    pincode: string = ""
    country?: string = ""
    // otp: string = ""
}



export class NRITinFormReq {
    fatcaIdentificationType!: string
    fatcaTin!: string
    nriUploadedFile?: File | null
    nriUploadedBase64?: string
    fatcaTinTaxStatus!: "individual" | "entity"
}

export class NRITinDetails {
    nriTinUpdatedAt?: Date
    fatcaIdType?: string
    fatcaTpin?: string
    fatcaCountry!: string
    noTin!: boolean
    name!: string;
    individualRegex!: string
    individualSampleText!: string
    entitiesRegex!: string
    entitiesSampleText!: string
    fatcaTinTaxStatus?: 'entity' | 'individual'

}